import React from "react";

interface ReviewCardProps {
  title: string;
  date: string;
  author: string;
  description: string;
  rating: number;
}

export const ReviewCard = ({
  title,
  date,
  author,
  description,
  rating,
}: ReviewCardProps) => {
  const stars = rating;
  return (
    <div className="card-review">
      <div className="card-review__header">
        <div className="card-review__header-rating">
          <div className="review-rating">
            <div className="review-rating__grp">
              {[...Array(stars)].map((_, index) => (
                <span className="review-rating__icon review-rating__icon--full">
                  <i className="icon icon-vpro-star-filled"></i>
                </span>
              ))}
            </div>
          </div>
        </div>
        <div className="card-review__header-date">{date}</div>
      </div>
      <div className="card-review__title">{title}</div>
      <div className="card-review__reviewer">{author}</div>
      <div className="card-review__data">{description}</div>
      {/* <div className="card-review__vote">
        <div className="card-review__vote-votes">
          <button
            type="button"
            className="btn btn-rounded btn-rounded-secondary tippy"
            data-tippy-content="Esta review fue util"
            aria-label="La review fue util"
          >
            <i className="icon icon-thumb-up"></i>
          </button>
          <button
            type="button"
            className="btn btn-rounded btn-rounded-secondary tippy"
            data-tippy-content="Esta review no fue util"
            aria-label="La review no fue util"
          >
            <i className="icon icon-thumb-down"></i>
          </button>
        </div>
        <div className="card-review__vote-report">
          <a href="">Reportar abuso</a>
        </div>
      </div> */}
    </div>
  );
};
